import React, { Component } from 'react';
import moment from 'moment';
import ReactSelect from 'react-select';
import classnames from 'classnames';
import {FaRegEye, FaEdit, FaEnvelope, FaEnvelopeOpenText} from "react-icons/fa";
import { getUserCountQuestion, setUserPaidDate, sendConfirm, sendLoginUser } from './actions';
import { Spin, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { required, numericality } from 'redux-form-validators';
import InputField from '../../helpers/Fields/InputField';
import { Field, reduxForm } from 'redux-form'
import QbmModal from '../../modals/common/QbmModal';
import PropTypes from 'prop-types';
import {cloneDeep} from 'lodash';
import Spiner from '../../helpers/Spiner/Spiner';
import {toastr} from 'react-redux-toastr'
import NewTransaction from './components/NewTransaction/NewTransaction';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;


class TableTr extends Component {
  static contextTypes = {formatMessage: PropTypes.any}

  constructor(props) {
    super(props)
    this.state = {
      loaded_count: false,
      editPaid: false,
      counts: {
        white: 0,
        red: 0,
        green: 0,
        total: 0,
      },
      spiner_modal: false
    }
  }

  async componentDidMount(){
    const {user} = this.props;
    const res = await getUserCountQuestion({user_id: user.id});
    const counts = {
      total: 0,
    };

    res.forEach(item => {
      if(item.status == 2){
        counts.white = item.count;
        counts.total += parseInt(item.count)
      }

      if(item.status == 3){
        counts.red = item.count;
        counts.total += parseInt(item.count)

      }

      if(item.status == 1){
        counts.green = item.count;
        counts.total += parseInt(item.count)

      }

    })
    this.setState({
      counts,
      loaded_count: true,
    });
  }

  updateUser = async (values) => {
    const { user, toggleSort, sort } = this.props;
    this.setState({spiner_modal: true});
    let tmp_user = await setUserPaidDate({
      user_id: user.id,
      months: values.months
    });
    this.setState({editPaid: false, spiner_modal: false})
    this.props.updateUser({id: tmp_user.id, payment_date_active: tmp_user.payment_date_active, is_payment: tmp_user.is_payment})
  }

  sendConfirm = async () => {
    const {formatMessage} = this.context;
    try {
      const { user } = this.props;
      await sendConfirm({user_id: user.id});
      toastr.success(formatMessage('msgConfirmTitleSuccess'), formatMessage('msgConfirmMessageSuccess'))

    } catch (error) {
      toastr.error(formatMessage('msgConfirmTitleError'), formatMessage('msgConfirmMessageError'))
    }
  }

  sendLoginUser = async () => {
    const {formatMessage} = this.context;
    try {
      const { user } = this.props;
      await sendLoginUser({user_id: user.id});
      toastr.success(formatMessage('msgLoginTitleSuccess'), formatMessage('msgLoginMessageSuccess'))
    } catch (error) {
      toastr.error(formatMessage('msgLoginTitleError'), formatMessage('msgLoginMessageError'))
    }
  }
  
  render() {
    const {formatMessage} = this.context;

    const {pagination, index, handleSubmit, user, handleChangeAccount, getLastLoginClass, accountList, statusList, handleChangeStatus, handleRowClick} = this.props;
    const {counts, loaded_count, editPaid, spiner_modal} = this.state;
    return (
      <tr>
        <td>{user.id}</td>
        <td>{user.username}</td>
        <td>{user.email}</td>
        <td>
            {!loaded_count && <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}><Spin indicator={antIcon} /></div>}
            {loaded_count && <span className={'questions general white'}>{counts.white}</span>}
            {loaded_count && <span className={'questions enabled red'}>{counts.red}</span>}
            {loaded_count && <span className={'questions status-disabled green'}>{counts.green}</span>}
            {loaded_count && <span className={'questions temp total'}>{counts.total}</span>}
        </td>
        <td className={getLastLoginClass(user)}>{user.last_login && moment.unix(user.last_login).format(' MMMM DD YYYY, h:mm:ss a')}</td>
        <td>
          <div style={{display: 'flex', alignItems: 'center'}}>
            {!user.is_payment ? <span class="questions status-disabled">Not paid</span> : <span className={'questions enabled'}>Paid</span> }
            <FaEdit onClick={() => {this.setState({editPaid: true})}} className={'icon'} />
            {editPaid && <QbmModal
              show={editPaid}
              title={'Paid'}
              onClose={() => {this.setState({editPaid: false})}}
            >
              {spiner_modal && <div style={{height: '250px', width: '100%', background: 'white'}}>
                <Spiner/>
              </div>}
              {!spiner_modal && <form className="create-dialog-form" onSubmit={handleSubmit(this.updateUser)}>
               
                <Field
                  name="months"
                  label={formatMessage('lbInputPaidUserMonths')}
                  component={InputField}
                  validate={[required(), numericality({int: true, '>': 0, '<': 100})]}
                />
                <div className="actions" style={{display: 'flex', justifyContent: 'space-between'}}>
                  <button
                      className="btn btn-primary"
                      type="submit"
                  >{formatMessage('btnUserPaid')}</button>
                  <button
                      className="btn btn-primary"
                      type="button"
                      onClick={() => this.updateUser({months: 0})}
                  >{formatMessage('btnUserUnPaid')}</button>
                </div>
              </form>}
            </QbmModal>}
          </div>
        </td>
        <td>
            {user.payment_date_active && user.payment_date_active > 0 ? moment.unix(user.payment_date_active).format('MMMM DD YYYY') : '-'}
        </td>
        <td>
            <ReactSelect
                valueKey={'id'}
                labelKey={'name'}
                options={accountList}
                value={user.account}
                clearable={false}
                onChange={(e) => handleChangeAccount(user.id, e)}
            />
        </td>
        <td>
            <ReactSelect
                valueKey={'id'}
                labelKey={'name'}
                options={statusList}
                value={user.status}
                clearable={false}
                onChange={(e) => handleChangeStatus(user.id, e)}
            />
        </td>
        <td>
          <span>{user.is_organisation == 1 ? 'Organisation' : user.owner ? user.owner.organisation_name || user.owner.id : 'Personal'} </span>
        </td>
        <td>
          {user.verify_email == 0 && <span class="questions status-disabled">Not verified</span>}
          {user.verify_email == 1 && <span class="questions enabled">Verified</span>}
        </td>
        <td>
            <span className={classnames('status',
                {'status-active': user.status == 10},
                {'status-disabled': user.status == 0})
            }></span>
        </td>
        <td style={{minWidth: 154}}>
            <Tooltip placement="topRight" title={formatMessage('msgTitleNewTransaction')}>
              <NewTransaction user_id={user.id}/>
            </Tooltip>
            <Tooltip placement="topRight" title={formatMessage('msgTitleView')}>
              <FaRegEye style={{marginLeft: 10}} onClick={() => handleRowClick(user)} className={'icon'}/>
            </Tooltip>
            <Tooltip placement="topRight" title={formatMessage('msgTitleSendConfirm')}>
              <FaEnvelope style={{marginLeft: 10}} onClick={this.sendConfirm} className={'icon'}/>
            </Tooltip>
            <Tooltip placement="topRight" title={formatMessage('msgTitleSendLoginUser')}>
              <FaEnvelopeOpenText style={{marginLeft: 10}} onClick={this.sendLoginUser} className={'icon'}/>
            </Tooltip>  
        </td>
      </tr>
    );
  }
}
export default reduxForm({
  form: 'update_paid'
})(TableTr)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Users/TableTr.jsx